import React, { useEffect, useState } from "react";
import {
  Input,
  notification,
  Drawer,
  Spin,
  Collapse,
  Pagination,
  Button,
  Tag,
  Empty,
} from "antd";
import "swiper/css";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { _get_business_transactions } from "../../common/axios_services";
import FooterDisplay from "../../components/footer";
import { useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import TopNav from "../../components/top-nav";

const RestaurantTransactions = () => {
  const Navigate = useNavigate();
  const userProfile = useSelector((state) => state.userProfile.dataFetched);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      description: message,
    });
  };
  const [currentHistDisp, setCurrentHistDisp] = useState("wallet");
  const majorSpinnerIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [majorPageSpinner, setMajorPageSpinner] = useState(true);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const params = new URLSearchParams(window?.location?.search);
  const [order_his, setOrder_his] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [per_page, setPer_page] = useState(10);
  const [total_trans, setTotal_trans] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const allTransOrders = async () => {
    try {
      setMajorPageSpinner(true);
      const response = await _get_business_transactions(page, per_page);
      const transactions = response?.data?.data?.transactions || [];
      const pagination = response?.data?.data?.pagination || {};

      setOrder_his(transactions);
      setTotal_trans(pagination.total || 0);
    } catch (err) {
      console.error("Error loading:", err);
      openNotificationWithIcon("error", "Failed to load transactions");
    } finally {
      setMajorPageSpinner(false);
    }
  };

  useEffect(() => {
    allTransOrders();
  }, [per_page, page]);

  const change_page = (selected_page, pageSize) => {
    setPage(selected_page);
    setPer_page(pageSize);
  };

  const handleRefresh = async () => {
    setPage(1);
    await allTransOrders();
  };

  // ACTION VIEW
  const handleViewClick = (record) => {
    setSelectedOrder(record);
    setIsModalVisible(true);
  };

  return (
    <div className="wise9ja-content">
      <div>
        <Spin indicator={majorSpinnerIcon} spinning={majorPageSpinner}>
          <div className="homepage wise9ja-disp">
            <div className="homepage-history-header">
              <TopNav title="Transactions" />
            </div>
            <div className="hero-sect mt_2"></div>
            <div className="content-display-content">
              <div className="contain">
                <div className="wise9ja-action-bar"></div>
                <div className="mt history-data-detail">
                  <div className="contai">
                    {!majorPageSpinner ? (
                      <>
                        {order_his.length === 0 ? (
                          <Empty description="No transactions found">
                            <Button type="primary" onClick={handleRefresh}>
                              Refresh
                            </Button>
                          </Empty>
                        ) : (
                          <div className="mobile topup-data">
                            <Collapse defaultActiveKey={[0]}>
                              {order_his.map((order, index) => (
                                <Collapse.Panel
                                  showArrow={false}
                                  key={index}
                                  header={
                                    <p style={{ display: "inline" }}>
                                      {order.description} -{" "}
                                      {new Date(
                                        order.createdAt,
                                      ).toLocaleString()}
                                    </p>
                                  }
                                >
                                  <div>
                                    <ul className="mobile-list-flex">
                                      <li>
                                        <span>Date: </span>
                                        <span>
                                          {new Date(
                                            order.createdAt,
                                          ).toLocaleString()}
                                        </span>
                                      </li>
                                      <li>
                                        <span>Ref Code: </span>
                                        <span>
                                          #{order.externalRef || order.id}
                                        </span>
                                      </li>
                                      <li>
                                        <span>Amount: </span>
                                        <span>
                                          ₦
                                          <NumberFormat
                                            thousandSeparator={true}
                                            prefix={""}
                                            className="numeric"
                                            displayType={"text"}
                                            value={parseFloat(
                                              order.amount,
                                            ).toFixed(2)}
                                          />{" "}
                                        </span>
                                      </li>
                                      <li>
                                        <span>Type: </span>
                                        <span>
                                          <Tag
                                            color={
                                              order.type === "CREDIT"
                                                ? "green"
                                                : "red"
                                            }
                                          >
                                            {order.type}
                                          </Tag>
                                        </span>
                                      </li>
                                      <li>
                                        <span>Status: </span>
                                        <span>
                                          <Tag
                                            color={
                                              order.status === "SUCCESSFUL"
                                                ? "green"
                                                : "orange"
                                            }
                                          >
                                            {order.status.toLowerCase()}
                                          </Tag>
                                        </span>
                                      </li>
                                      {order.hasFee && (
                                        <li>
                                          <span>Fee: </span>
                                          <span>₦{parseFloat(order.feeAmount || 0).toFixed(2)}</span>
                                        </li>
                                      )}
                                    </ul>
                                    <div className="mt-3">
                                      <Button
                                        onClick={() => handleViewClick(order)}
                                        type="link"
                                      >
                                        View Details
                                      </Button>
                                    </div>
                                  </div>
                                </Collapse.Panel>
                              ))}
                            </Collapse>
                            <div style={{ marginTop: "2%" }}></div>
                            <Pagination
                              showSizeChanger
                              current={page}
                              total={total_trans}
                              showTotal={(total, range) =>
                                `${range[0]}-${range[1]} of ${total} transactions`
                              }
                              defaultPageSize={per_page}
                              onChange={change_page}
                            />
                          </div>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
      <FooterDisplay />

      <Drawer
        title="Transaction Details"
        placement="bottom"
        onClose={() => setIsModalVisible(false)}
        open={isModalVisible}
        className={"px-8 h-[80vh]"}
        width={720}
        height="100%"
      >
        {selectedOrder && (
          <div className="space-y-4">
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
              <div className="text-gray-600">Ref Code</div>
              <div className="text-2xl font-bold text-gray-900 font-mono">
                #{selectedOrder.externalRef || selectedOrder.id}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="p-3 bg-gray-50 rounded-lg">
                <div className="text-xs text-gray-600 uppercase font-semibold">
                  Type
                </div>
                <div className="mt-2">
                  <Tag
                    color={selectedOrder.type === "CREDIT" ? "green" : "red"}
                    style={{ fontSize: "12px", padding: "4px 8px" }}
                  >
                    {selectedOrder.type}
                  </Tag>
                </div>
              </div>
              <div className="p-3 bg-gray-50 rounded-lg">
                <div className="text-xs text-gray-600 uppercase font-semibold">
                  Status
                </div>
                <div className="mt-2">
                  <Tag
                    color={
                      selectedOrder.status === "SUCCESSFUL" ? "green" : "orange"
                    }
                    style={{ fontSize: "12px", padding: "4px 8px" }}
                  >
                    {selectedOrder.status}
                  </Tag>
                </div>
              </div>
            </div>

            <div className="p-4 bg-green-50 rounded-lg border border-green-200">
              <div className="text-gray-600 mb-1">Amount</div>
              <div className="text-3xl font-bold text-green-600">
                <NumberFormat
                  thousandSeparator={true}
                  prefix="₦"
                  displayType="text"
                  value={parseFloat(selectedOrder.amount || 0).toFixed(2)}
                />
              </div>
            </div>

            <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
              <div className="flex justify-between items-start">
                <span className="text-gray-600 font-semibold">Date</span>
                <span className="text-gray-900 font-medium">
                  {new Date(selectedOrder.createdAt).toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between items-start border-t pt-2">
                <span className="text-gray-600 font-semibold">Description</span>
                <span className="text-gray-900 font-medium text-right">
                  {selectedOrder.description}
                </span>
              </div>
              <div className="flex justify-between items-start border-t pt-2">
                <span className="text-gray-600 font-semibold">Tag</span>
                <span className="text-gray-900 font-medium">
                  {selectedOrder.tag}
                </span>
              </div>
            </div>

            {selectedOrder.hasFee && (
              <div className="space-y-3 p-4 bg-orange-50 rounded-lg border border-orange-200">
                <div className="font-semibold text-orange-900 mb-3">
                  Fee Details
                </div>
                <div className="flex justify-between items-center py-2">
                  <span className="text-gray-700">Transfer Amount</span>
                  <span className="font-semibold text-gray-900">
                    <NumberFormat
                      thousandSeparator={true}
                      prefix="₦"
                      displayType="text"
                      value={parseFloat(
                        selectedOrder.transferAmount || 0,
                      ).toFixed(2)}
                    />
                  </span>
                </div>
                <div className="border-t border-orange-200"></div>
                <div className="flex justify-between items-center py-2">
                  <span className="text-gray-700">Fee Amount</span>
                  <span className="font-semibold text-red-600">
                    <NumberFormat
                      thousandSeparator={true}
                      prefix="₦"
                      displayType="text"
                      value={parseFloat(selectedOrder.feeAmount || 0).toFixed(
                        2,
                      )}
                    />
                  </span>
                </div>
                <div className="border-t border-orange-200"></div>
                <div className="flex justify-between items-start py-2">
                  <span className="text-gray-700">Fee Description</span>
                  <span className="font-medium text-gray-900 text-right">
                    {selectedOrder.feeDescription}
                  </span>
                </div>
              </div>
            )}
          </div>
        )}
      </Drawer>
    </div>
  );
};

export default RestaurantTransactions;
